export default __webpack_public_path__ + "static/media/loading.5da7e026.svg";